export default __webpack_public_path__ + "static/media/home-business-corporate-img-01.4121b50a.jpg";